import React from "react";
import { TAGGED_CAMPAIGN_STATUSES } from "../../utils/constants/CategoryTrackMapping";
import StatusChip from "../common/StatusChip";

/** Active / Paused (or closed) chip for a campaign's own status on Meta. */
const CampaignStatusTag = ({ status }) => {
  if (!TAGGED_CAMPAIGN_STATUSES.includes(status)) return null;

  return <StatusChip subtle status={`campaign_${status.toLowerCase()}`} />;
};

export default CampaignStatusTag;
